import {filter, first} from "rxjs/operators";
import {Tour} from '@app/common/interfaces/tour';
import {LngKeys} from "@app/common/enums/lng-keys";
import {FooterComponent} from '@app/common/ui-kits';
import {Quotes} from '@app/common/interfaces/quotes';
import {TranslateService} from "@ngx-translate/core";
import {HttpErrorResponse} from '@angular/common/http';
import {inject as vercel_inject} from '@vercel/analytics';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {LANGUAGES_OBJ} from "@app/common/constants/languages_data";
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {ShoppingService} from '@app/common/services/shopping.service';
import {CurrencyService} from '@app/common/services/currency.service';
import {AppStateService} from '@app/common/services/app-state.service';
import {Component, DestroyRef, inject, OnInit, PLATFORM_ID, Renderer2} from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    FooterComponent
  ]
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly document = inject(DOCUMENT);
  private readonly renderer = inject(Renderer2);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly destroyRef = inject(DestroyRef);
  private readonly currencyService = inject(CurrencyService);
  private readonly appStateService = inject(AppStateService);
  private readonly shoppingService = inject(ShoppingService);
  private readonly translateService = inject(TranslateService);

  ngOnInit(): void {
    // this.translationService.setLanguage();

    this.getLngFromRoute();
    this.onLangChange();

    if (isPlatformBrowser(this.platformId)) {
      // this.clearStorageAfterPeriodTime();
      this.resetToursAfterPageReload();
      this.getCurrency();
      vercel_inject();
    }
  }

  private onLangChange() {
    this.translateService.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.appStateService.dateTime = new Date().getTime();

        Object.values(LngKeys).forEach((key) => {
          this.renderer.removeClass(this.document.body, `lang_${key}`);
        });

        this.renderer.addClass(this.document.body, `lang_${res.lang}`);

        this.appStateService.setHtmlLangAttribute(res.lang, this.renderer);
        this.appStateService.addMetaTags(LANGUAGES_OBJ[res.lang as LngKeys].seo);
      });
  }

  private getLngFromRoute() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        first()
      )
      .subscribe(() => {
        const lng = this.currentLngKey;
        this.appStateService.setLng(lng);
      });
  }

  private get currentLngKey() {
    const cleanUrl = this.router.url.split('?')[0]; // Remove query params
    const paths = cleanUrl.split('/').filter((path) => path.length);

    let lng: LngKeys = paths.at(0) as LngKeys || LngKeys.EN;
    if (!Object.values(LngKeys).includes(lng as LngKeys)) {
      lng = LngKeys.EN;
    }

    return lng;
  }

  /*private clearStorageAfterPeriodTime() {
    const time_now: number = (new Date()).getTime();
    let lastClear = getItemStore<number>('lastClear');

    if (!lastClear) {
      localStorage.clear();
      setItemStore<number>('lastClear', time_now);
      lastClear = time_now;
    }
    // .getTime() returns milliseconds so 1000 * 60 * 60 * 24 = 24 days
    if ((time_now - lastClear) > 1000 * 60 * 60 * 24) {
      localStorage.clear();
      setItemStore<number>('lastClear', lastClear);
    }
  }*/

  private resetToursAfterPageReload(): void {
    this.shoppingService.shoppedTours = [];
    this.shoppingService.shoppedToursIds.forEach((id: string) => {
      const existTour = this.appStateService.tours.find((tour: Tour) => tour.id === id);
      if (existTour) {
        this.shoppingService.shoppedTours.push(existTour);
      }
    });
    // setItemStore<Tour[]>('shoppedTours', this.shoppingService.shoppedTours);
  }

  private getCurrency(): void {
    this.currencyService.getCurrency()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: Quotes) => {
          this.appStateService.quotes = res;
        },
        (err: HttpErrorResponse) => console.log(err)
      );
  }

}

